/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import style from '../../../../../assets/styles/testCreationStyle.module.css';
import {
  Add_Section_Test,
  change_test_screen,
  changeAdd_test_screen,
  Get_All_Identifier,
  Get_Replace_question,
} from '../../../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import BrowsingQuestion from '../AddTest/BrowsingQuestion';
import {
  CREATE_TESTS_BASIC_SETTING,
  CREATE_TESTS_SECTION,
  GET_QUASI_SECTION_QUESTION,
  GET_REVIEW_DATA,
  GET_USERS,
} from '../../../../../action/apiPath';
import { CallWithAuth } from '../../../../../action/apiActions';
import moment from 'moment';
import QuillEditor from '../../../../atoms/QuillEditor';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import infoIcon from '../../../../../assets/images/info.svg';
import deleteId from '../../../../../assets/images/deleteId.svg';
import { useToast } from '../../../common/Toast';
import { CREATE_TEST_SECTION_SUCCESS } from '../../../../../redux/constant';
import PreviewModal from '../../../../atoms/Modal/PreviewModal';
import LockModal from '../../../../atoms/Modal/LockModel';
import QuestionListModal from '../../../../atoms/Modal/QuestionListModal';
import { openPreviewModal, closePreviewModal } from '../../../../atoms/Modal/modalHandlers';
import { editQuestionHandler } from '../../../../atoms/Modal/editHandlers';
import { handleDuplicate, openModalHelper, closeModalHelper } from '../../../../atoms/Modal/duplicateHelper';
import { handleConfirmDuplicate } from '../../../../atoms/Modal/duplicateInPreviewHelper';
import { useNavigate } from 'react-router-dom';
import quasiReplace from '../../../../../assets/images/quasiReplace.svg';
import quasiDelete from '../../../../../assets/images/quasiDelete.svg';
import passageVerticalLineSvg from '../../../../../assets/images/passageVerticalLine.svg';
import colapseIcon from '../../../../../assets/images/next.svg';
import Loader from '../../../../loader';
const QuasiSections = ({ isEdit, onAdd, isView, getData }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [questionAccess, setQuestionAccess] = useState({});
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null); // State to store dataToPass
  const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
  const [actionId, setactionId] = useState(null);
  const [questionCategory, setQuestionCategory] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const userId = JSON.parse(localStorage.getItem('userInfo')).id;
  const [bankId, setBankId] = useState(null);
  const [modalMedium, setModalMedium] = useState(false);
  const [questionItem, setQuestionItem] = useState({});
  const [selectIds, SetSelectIds] = useState([]);
  const [modalModalData] = useState({
    title: 'This Question is Linked to Existing Tests',
    description:
      'The question you are about to edit has been used in one or more tests. Please be sure to click the ‘Update Exam’ button to update the changes across all tests that include this question.',
    cancelButton: 'Cancel',
    saveButton: 'Continue',
    substitle: 'Are you sure you want to proceed with editing this question?',
    className: 'quasi_modal',
  });
  const getPermission = async () => {
    const Permission = await CallWithAuth('GET', `${GET_USERS}${userId}/user-details/`);
    if (Permission.status && Permission.res.status === 200) {
      const data = Permission.res.data;
      sessionStorage.setItem('permissionForQuestions', JSON.stringify(data));
    } else if (Permission.status && Permission.res.status === 400) {
      // eslint-disable-next-line no-console
      console.log('Access denied, you do not have permission to access source question bank');
    }
  };
  const [collapse, setCollapse] = useState({});
  const toggleCollapse = (Id) => {
    setCollapse((prev) => ({
      ...prev,
      [Id]: !prev[Id], // Toggle only the clicked rule's state
    }));
  };
  useEffect(() => {
    getPermission();
  }, []);

  useEffect(() => {
    const Permission = JSON.parse(sessionStorage.getItem('permissionForQuestions') || '{}');
    const newQuestionAccess = Permission?.question_bank_management?.filter((item) => item.id === bankId)[0];
    if (Permission && newQuestionAccess) {
      sessionStorage.setItem('questionAccess', JSON.stringify(newQuestionAccess));
      setQuestionAccess(newQuestionAccess);
    } else {
      setQuestionAccess({});
      const payload = { draft: false, edit: false, review: false, view: false, id: questionBankId };
      sessionStorage.setItem('questionAccess', JSON.stringify(payload));
    }
  }, [bankId]);
  const organizationId = localStorage.getItem('selectedOrgId');

  useEffect(() => {
    dispatch(Get_All_Identifier(organizationId, '', ''));
  }, []);
  const { identifierList, sectionBody, testCreationId, replacedQuestion, getBasicSettingData, testDetails } =
    useSelector((state) => state.GetAllData);
  const [showPopup, setShowPopup] = useState(false);
  const [body, setBody] = useState({
    groups: [
      {
        randomize_sections: false,
        sections: [
          {
            order: 1,
            section_name: '',
            identifier: null,
            instructions: [
              {
                has_timer: false,
                minutes: null,
                seconds: null,
                instruction_text: '',
              },
            ],
            no_of_rounds: '',
            initial_scale_score: '',
            min_score: '',
            max_score: '',
            unattempted_penalty: testDetails?.unattempted_penalty ?? getBasicSettingData?.unattempted_penalty,
            sets: [
              {
                id: 1,
                setCode: '',
                set_name: '',
                round_no: '',
                no_of_questions: '',
                randomize_questions_within_set: false,
                set_picking_from: '',
                set_picking_to: '',
                scaled_score_adjustment: [
                  {
                    no_of_qn_correct: '',
                    adjust_marks: '',
                  },
                ],
                questions: [],
              },
            ],
          },
        ],
      },
    ],
  });
  //__________ Group -> add , remove , drag & drop __________
  const [groupsButton] = useState(0);
  const [section, setSection] = useState([0, 1]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [sectionButton, setSectionButton] = useState(0);
  const [testType, setTestType] = useState(0);
  const [groupedSections, setGroupedSections] = useState(body?.groups[groupsButton]?.sections);
  useEffect(() => {
    if (body.groups[groupsButton].sections[sectionButton] === undefined) {
      setSectionButton(body.groups[groupsButton].sections.length - 1);
    }
  }, [groupsButton]);
  useEffect(() => {
    setTestType(testDetails?.test_type ?? getBasicSettingData?.test_type);
  }, [getBasicSettingData]);
  const [groups, setGroups] = useState([{ id: 0, sections: [0] }]);

  const addSection = (groupId) => {
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const newSectionId = group.sections.length;
          return {
            ...group,
            sections: [...group.sections, newSectionId],
          };
        }
        return group;
      })
    );

    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId) {
            const newSection = {
              order: group.sections.length + 1,
              section_name: '',
              identifier: null,
              instructions: [
                {
                  has_timer: false,
                  minutes: null,
                  seconds: null,
                  instruction_text: '',
                },
              ],
              no_of_rounds: '',
              initial_scale_score: '',
              min_score: '',
              max_score: '',
              unattempted_penalty: testDetails?.unattempted_penalty ?? getBasicSettingData?.unattempted_penalty,
              sets: [
                {
                  id: 1,
                  setCode: '',
                  set_name: '',
                  round_no: '',
                  no_of_questions: '',
                  randomize_questions_within_set: false,
                  set_picking_from: '',
                  set_picking_to: '',
                  scaled_score_adjustment: [
                    {
                      no_of_qn_correct: '',
                      adjust_marks: '',
                    },
                  ],
                  questions: [],
                },
              ],
            };
            return {
              ...group,
              sections: [...group.sections, newSection],
            };
          }
          return group;
        }),
      };
    });
  };
  const [markingState, setMarkingState] = useState([]);
  const deleteSection = (groupId, sectionIndex) => {
    // Ensure there's more than one section before deleting
    setGroups((prevGroups) => {
      return prevGroups.map((group) => {
        if (group.id === groupId && group.sections.length > 1) {
          return {
            ...group,
            sections: group.sections.filter((_, idx) => idx !== sectionIndex),
          };
        }
        return group;
      });
    });
    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId && group.sections.length > 1) {
            const updatedSections = group.sections.filter((_, idx) => idx !== sectionIndex);
            // Recalculate the order
            updatedSections.forEach((section, idx) => {
              section.order = idx + 1;
            });
            return {
              ...group,
              sections: updatedSections,
            };
          }
          return group;
        }),
      };
    });
    // Update sectionButton if necessary
    setSectionButton((prevButton) => {
      // If the deleted section was the last one, move selection one section back.
      if (prevButton === sectionIndex && prevButton > 0) {
        return prevButton - 1;
      }
      // Otherwise, remain on the current selection or adjust if out of bounds.
      const maxIndex = groups[groupsButton]?.sections?.length - 2;
      return Math.min(prevButton, maxIndex);
    });
  };
  useEffect(() => {
    SetSelectIds([]);
  }, [sectionButton]);
  const ChangeQuasiSectionName = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].section_name = e.target.value;
    setBody(updatedBody);
  };

  const ChangeSectionIdentifier = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].identifier = Number(e.target.value);
    setBody(updatedBody);
  };
  const ChangeNoOfRound = (e) => {
    const updatedBody = { ...body };
    let value = e.target.value;
    if (value !== '' && value <= 0) {
      value = 1;
    }
    if (value !== '' && value > 999) {
      toast?.remove('all');
      toast?.add('Enter no. of round from 1 to 999', 'error');
      value = 999;
    }
    if (value === '') {
      value = '';
    }
    updatedBody.groups[groupsButton].sections[sectionButton].no_of_rounds =
      value === '' ? value : Number(Math.trunc(value));
    setBody(updatedBody);
  };
  const ChangeInitialScore = (e) => {
    const updatedBody = { ...body };
    const value = e.target.value;
    updatedBody.groups[groupsButton].sections[sectionButton].initial_scale_score = value === '' ? value : Number(value);
    setBody(updatedBody);
  };
  const ChangeHighestScore = (e) => {
    const updatedBody = { ...body };
    const value = e.target.value;
    updatedBody.groups[groupsButton].sections[sectionButton].max_score = value === '' ? value : Number(value);
    setBody(updatedBody);
  };
  const ChangeLowestScore = (e) => {
    const updatedBody = { ...body };
    const value = e.target.value;
    updatedBody.groups[groupsButton].sections[sectionButton].min_score = value === '' ? value : Number(value);
    setBody(updatedBody);
  };
  const changeUnattemptedPenalty = (e) => {
    const value = e.target.value === '' ? e.target.value : Number(e.target.value);
    setBody((prevBody) => {
      const updatedBody = { ...prevBody };
      updatedBody.groups[groupsButton].sections[sectionButton].unattempted_penalty = value;
      updatedBody.groups[groupsButton].sections[sectionButton].sets
        .find((set) => set.id === selectedSetId)
        .questions.forEach((question) => {
          question.unattempted_penalty = value;
          question.questions.map((item) => (item.unattempted_penalty = value));
        });
      return updatedBody;
    });
  };
  const changeQueUnattemptedPenalty = (e, i) => {
    const value = Number(e.target.value);
    setBody((prevBody) => {
      const updatedBody = { ...prevBody };
      updatedBody.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId).questions[
        i
      ].unattempted_penalty = value;
      return updatedBody;
    });
  };
  const [disableMarking, setDisableMarking] = useState(true);

  useEffect(() => {
    if (getBasicSettingData !== null) {
      console.log(getBasicSettingData);
    }
  }, [getBasicSettingData]);

  const [modal, setModal] = useState(false);

  const AddQuestionFromBank = () => {
    // Check if currentSet exists and has a valid number of questions
    if (
      body.groups[groupsButton]?.sections[sectionButton]?.sets.find((set) => set.id === selectedSetId)
        ?.no_of_questions > 0
    ) {
      setRemoveId([]);
      SetSelectIds([]);
      const currentSet = body.groups[groupsButton]?.sections[sectionButton]?.sets.find(
        (set) => set.id === selectedSetId
      );
      if (currentSet && currentSet.questions) {
        const questionIds = currentSet?.questions?.map((question) => question?.question_id);
        SetSelectIds(questionIds);
      }
      setModal(true);
    } else {
      toast?.remove('all');
      toast?.add('Please choose no. of questions first', 'error');
    }
  };

  const AddToTestPaper = () => {
    if (selectIds.length === 0) {
      toast?.remove('all');
      toast?.add('Please select a question to add', 'error');
      return;
    }
    setquestionId(selectIds);

    const updatedGroups = { ...body };
    const currentSection = updatedGroups.groups[groupsButton].sections[sectionButton];
    const currentSet = currentSection.sets.find((set) => set.id === selectedSetId);
    if (selectIds.length > currentSet.questions.flatMap((q) => q.questions).length) {
      const existingQuestionIds = new Set(
        currentSet.questions.flatMap((q) => q.questions.map((question) => question.question_id))
      );
      // const newQuestions = selectIds
      //   .filter((id) => !existingQuestionIds.has(id))
      //   .map((id, index) => ({
      //     questions: [
      //       {
      //         question_id: id,
      //         unattempted_penalty: currentSection.unattempted_penalty,
      //         order: index + 1,
      //       },
      //     ],
      //   }));
      const newQuestions = selectIds
        .filter((id) => !existingQuestionIds.has(id))
        .map((id, index) => ({
          question_id: id,
          unattempted_penalty: currentSection.unattempted_penalty,
          order: currentSet.questions.length > 0 ? currentSet.questions.length + 1 : index + 1,
        }));
      currentSet.questions.push(...newQuestions);
    } else {
      const removedIds = currentSet.questions
        .flatMap((q) => q.questions)
        .filter((question) => !selectIds.includes(question.question_id))
        .map((question) => question.question_id);
      if (removedIds.length > 0) {
        const filteredQuestions = currentSet.questions
          .map((q) => ({
            ...q,
            questions: q.questions.filter((question) => !removedIds.includes(question.question_id)),
          }))
          .filter((q) => q.questions.length > 0); // Remove empty drafts

        currentSet.questions = selectIds.map((question, index) => ({
          ...question,
          question_id: question,
          order: index + 1,
          unattempted_penalty: currentSection.unattempted_penalty,
        }));
      }
    }

    setBody(updatedGroups);
    QuestionListing();
    setModal(false);
  };
  const [removeId, setRemoveId] = useState([]);
  const [questionApiRender, setQuestionApiRender] = useState(false);

  const DeleteIdFromList = () => {
    if (removeId.length === 0) {
      toast?.add(' Please select a question to delete', 'error');
    }
    const filteredSelectIds = body?.groups[groupsButton]?.sections[sectionButton]?.sets
      .find((set) => set.id === selectedSetId)
      .questions?.map((q) => ({
        ...q,
        questions: q?.questions.filter((id) => !removeId.includes(id.question_id)), // Correct filtering
      }));
    const updatedGroups = { ...body };
    updatedGroups.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId).questions =
      filteredSelectIds.filter((item) => item?.questions.length).map((item, index) => ({ ...item, order: index + 1 }));

    setBody(updatedGroups);
    const message = `${removeId.length > 1 ? 'Questions' : 'Question'} deleted successfully`;
    toast?.add(message, 'success');
    setRemoveId([]);
  };

  const RemoveIds = (items, check) => {
    if (check) {
      setRemoveId((prevState) => [...prevState, items.question_id]);
    } else {
      const filteredArr = removeId.filter((value) => value !== items.question_id);
      setRemoveId(filteredArr);
    }
  };
  const removeQueIds = (e, items) => {
    // Stop event propagation
    if (e?.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    const newRemoveIds = [...removeId, items?.question_id];
    setRemoveId(newRemoveIds);
    const currentSet = body.groups[groupsButton].sections[sectionButton]?.sets.find((set) => set.id === selectedSetId);
    if (!currentSet) return;
    const filteredQuestions = currentSet.questions.map((q) => ({
      ...q,
      questions: q.questions.filter((innerQ) => !newRemoveIds.includes(innerQ.question_id)), // Correct filtering here
    }));
    const updatedBody = { ...body };
    const targetSet = updatedBody.groups[groupsButton].sections[sectionButton].sets.find(
      (set) => set.id === selectedSetId
    );
    const filteredValue = filteredQuestions?.filter((item) => item?.questions[0]);
    if (targetSet) {
      targetSet.questions = filteredValue;
    }
    setShowModal({});
    setBody(updatedBody);
    setRemoveId((prev) => prev.filter((id) => id !== items?.question_id));
    toast?.add('Question deleted successfully', 'success');
  };
  // question bank get
  // Get the current year
  const currentYear = new Date().getFullYear();
  // _________ PRIMARY TAG STATE INITIALIZATION _________
  const [questionId, setquestionId] = useState(0);
  const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([]);
  const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
  const [multiselectedCategoryTag, setmultiSelectedCategoryTag] = useState([]);
  const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
  const [sort, setSort] = useState('-created_at');
  // ________ PAGINATION ________

  const [totalCount, setTotalCount] = useState(0);
  const [last, setLast] = useState(5);
  const [offset, setOffset] = useState(0);
  // _________question bank id which is top dropdown _________
  const [questionBankId, setQuestionBankId] = useState(4);
  const [selectedSetId, setSelectedSetId] = useState(1);
  useEffect(() => {
    // alert(totalCount)
    if (totalCount < 5) {
      setLast(totalCount);
    } else {
      setLast(5);
    }
  }, [totalCount]);

  const [sortConfig, setSortConfig] = useState({
    field: 'created_at',
    direction: 'desc',
    sort: '-created_at',
  });

  const handleSort = (field) => {
    setSortConfig((prevConfig) => {
      let direction, sortValue;

      if (field === 'created_at') {
        if (prevConfig.field !== field) {
          direction = 'desc';
          sortValue = `-${field}`;
        } else {
          // Subsequent clicks toggle between asc and desc
          direction = prevConfig.direction === 'asc' ? 'desc' : 'asc';
          sortValue = direction === 'desc' ? `-${field}` : field;
        }
      } else {
        // General sorting logic for other fields
        direction = prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc';
        sortValue = direction === 'desc' ? `-${field}` : field;
      }

      setSort(sortValue);
      setSortConfig({ field, direction, sort: sortValue });
      return { field, direction, sort: sortValue };
    });
  };

  // _________ALL question created listing data _________
  const [questionResults, setQuestionResults] = useState([]);
  const QuestionListing = async () => {
    setIsLoading(true);
    const currentSection = body?.groups?.[groupsButton]?.sections?.[sectionButton];
    const currentSet = currentSection?.sets?.find((set) => set.id === selectedSetId);
    const questionsArray = currentSet?.questions;
    if (!currentSet || !currentSet.questions) {
      setIsLoading(false);
      return;
    }

    const questionIds = currentSet.questions
      .sort((a, b) => (a?.order || 0) - (b?.order || 0))
      .map((item) => {
        if (typeof item !== 'object' || item === null) return item;
        if (Array.isArray(item.questions)) {
          return item.questions.map((el) => (typeof el === 'object' && el !== null ? (el.question_id ?? el.id) : el));
        }
        return item.question_id ?? item.id;
      })
      .flat(Infinity)
      .filter((id) => id !== undefined && id !== null)
      .join(',');
    if (!questionIds) {
      setIsLoading(false);
      return;
    }
    const testId = testDetails?.id ?? testCreationId;
    const url = `${GET_QUASI_SECTION_QUESTION}${organizationId}/?question_ids=${questionIds}&test_id=${testId}`;
    //const url = `${GET_QUASI_SECTION_QUESTION}${organizationId}/?question_ids=${questionIds}`;
    try {
      const questionlistingData = await CallWithAuth('GET', url);
      if (questionlistingData.status && questionlistingData.res.status === 200) {
        const fetchedQuestions = questionlistingData.res.data;
        const formattedQuestions = fetchedQuestions.map((item, index) => ({
          ...item,
          order: item.order === null ? index + 1 : item.order,
        }));

        // Use functional state updater to avoid stale closure body issues
        setBody((prevBody) => {
          const updatedBody = { ...prevBody };
          const targetSet = updatedBody.groups?.[groupsButton]?.sections?.[sectionButton]?.sets?.find(
            (set) => set.id === selectedSetId
          );

          if (targetSet) {
            targetSet.questions = formattedQuestions;
          }
          return updatedBody;
        });

        setTotalCount(fetchedQuestions.reduce((sum, obj) => sum + (obj?.questions?.length || 1), 0));
      }
    } catch (error) {
      console.error('Error fetching question listing data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setGroupedSections(body.groups[groupsButton].sections || []);
  }, [body.groups[groupsButton].sections]);

  useEffect(() => {
    QuestionListing();
  }, [
    organizationId,
    selectedSetId,
    questionBankId,
    questionId,
    offset,
    sort,
    groupsButton,
    sectionButton,
    questionApiRender,
  ]);

  /*****Function to open edit / delete modal */
  const [showModal, setShowModal] = useState({});

  const handleClick = (index) => {
    setShowModal((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  // __________ outside clickable close modal _______________

  const modalRef = useRef();
  const actionButtonRef = useRef();
  // Modified outside click handler
  const handleOutsideClick = (event) => {
    // Check if click is on the three dots button
    if (actionButtonRef.current?.contains(event.target)) {
      return;
    }

    // Check if click is inside the modal
    if (modalRef.current?.contains(event.target)) {
      return;
    }

    // Only close if it's a true outside click
    setShowModal({});
  };
  useEffect(() => {
    // Add event listener to detect outside clicks
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const [replaceId, setReplaceId] = useState(null);

  const GetReplace = (event, items) => {
    // Stop event propagation
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setReplaceId(items.question_id);
    const testId = testDetails?.id ?? testCreationId;
    const sectionIDs = body.groups[groupsButton].sections[sectionButton]?.sets
      .find((set) => set.id === selectedSetId)
      ?.questions?.flatMap((q) => q?.questions?.map((item) => item.question_id));
    dispatch(Get_Replace_question(organizationId, items.question_id, sectionIDs, toast, testId));
  };

  useEffect(() => {
    if (replacedQuestion !== null) {
      // Create a deep copy of `body` to avoid direct mutations
      const updatedGroups = { ...body };

      const targetSection = updatedGroups.groups?.[groupsButton]?.sections?.[sectionButton];
      if (!targetSection) return;

      const targetSet = targetSection.sets?.find((set) => set.id === selectedSetId);
      if (!targetSet) return;
      // Iterate over all questions inside the sets and their nested questions
      targetSet.questions = targetSet.questions.map((questionSet) => ({
        ...questionSet,

        questions: questionSet?.questions?.map((nestedQuestion, index) =>
          nestedQuestion?.question_id === replaceId
            ? {
                ...nestedQuestion,
                ...replacedQuestion,
                question_id: replacedQuestion?.question_id,
                unattempted_penalty: targetSection?.unattempted_penalty,
              }
            : nestedQuestion
        ),
      }));

      // Update the state with the modified groups

      setBody(updatedGroups);

      setShowModal({});
      QuestionListing();
    }
  }, [replacedQuestion]);

  const GetDelete = (event, items) => {
    // Stop event propagation
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const filteredSelectIds = body.groups[groupsButton].sections[sectionButton]?.sets
      .find((set) => set.id === selectedSetId)
      .questions?.map((item) => {
        // Filter out the question with the matching ID
        const updatedQuestions = item.questions.filter((q) => q.question_id !== items.question_id);
        // Return a new object with the updated questions array
        return {
          ...item,
          questions: updatedQuestions,
        };
      })
      .filter((item) => item.questions.length)
      .map((item, index) => ({ ...item, order: index + 1 }));
    const updatedGroups = { ...body };
    updatedGroups.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId).questions =
      filteredSelectIds.map((item, index) => ({ ...item, order: index + 1 }));
    setBody(updatedGroups);
    setShowModal({});
    toast?.add('Question deleted successfully', 'success');
    // setReplaceId(items.question_id)
    // dispatch(Get_Replace_question(items.question_id,selectIds))
  };
  const [markingLogicStatus, setMarkingLogicStatus] = useState(false);

  const [markingLogic, setMarkingLogic] = useState([
    {
      unattempted_penalty: body.groups[groupsButton].sections[sectionButton]?.unattempted_penalty,
    },
  ]);

  const [checkedItems, setCheckedItems] = useState({}); // Object to track checked state for each item

  const handleCheckboxClick = (item, event) => {
    const isChecked = event.target.checked;

    // Update the checked state for the specific item
    setCheckedItems((prev) => ({
      ...prev,
      [item.id]: isChecked, // Assuming 'id' is a unique identifier for items
    }));

    // Perform additional action (RemoveIds) based on the checked state
    RemoveIds(item, isChecked);
  };
  // const handleCheckboxClick = (index) => {
  //   setIsChecked((prevState) => ({
  //     ...prevState,
  //     [index]: !prevState[index],
  //   }));
  // };
  const AddNewScore = () => {
    setMarkingLogic((prevState) => [
      ...prevState,
      {
        unattempted_penalty: body.groups[groupsButton].sections[sectionButton]?.unattempted_penalty,
      },
    ]);
  };

  // Function to handle change event
  const handleCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      unattempted_penalty: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  const handleOrderChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
  };
  const SelectedMarkingLogic = (items) => {
    const updatedData = { ...body };
    updatedData.groups[groupsButton].sections[sectionButton]?.sets
      .find((set) => set.id === selectedSetId)
      .questions.forEach((question) => {
        if (question.questions?.length) {
          question.questions.forEach((subQuestion, index) => {
            if (removeId.includes(subQuestion.question_id)) {
              question.unattempted_penalty = items.unattempted_penalty;
              subQuestion.unattempted_penalty = items.unattempted_penalty;
            }
          });
        }
      });
    setBody(updatedData);
    setRemoveId([]);
    setMarkingLogicStatus(!markingLogicStatus);
  };

  const OpenMarkingLogic = () => {
    if (Array.isArray(removeId) && removeId.length > 0) {
      setMarkingLogicStatus(!markingLogicStatus);
    } else {
      toast?.add('Please choose question first', 'error');
    }
  };

  const decodeBase64 = (base64String) => {
    return atob(base64String);
  };

  const handleTimerChange = (event, sectionIndex, instructionIndex, type) => {
    let value;
    if (type === 'has_timer') {
      value = event.target.checked;
    } else {
      value = parseInt(event.target.value, 10);
    }

    setBody((prevBody) => {
      // Clone the previous state
      const newBody = { ...prevBody };
      // Access the targeted instruction
      newBody.groups[groupsButton].sections[sectionButton].instructions[instructionIndex][type] = value;
      return newBody;
    });
  };

  const handleInstructionTextChange = (content, sectionIndex, instructionIndex) => {
    const answer = btoa(unescape(encodeURIComponent(content)));
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].sections[sectionButton].instructions[instructionIndex].instruction_text = answer;
      return newBody;
    });
  };

  const addScreen = (sectionIndex) => {
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].sections[sectionButton].instructions.push({
        has_timer: false,
        minutes: null,
        seconds: null,
        instruction_text: '',
      });
      return newBody;
    });
  };

  const removeScreen = (sectionIndex, instructionIndex) => {
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      newBody.groups[groupsButton].sections[sectionButton].instructions = newBody.groups[groupsButton].sections[
        sectionButton
      ].instructions.filter((_, i) => i !== instructionIndex);
      return newBody;
    });
  };

  const ChangeRandomize_Sections = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].randomize_sections = e;
    setBody(updatedBody);
  };
  const handleAddSet = () => {
    setBody((prevBody) => {
      const currentSection = prevBody.groups[groupsButton].sections[sectionButton];
      const currentSets = currentSection.sets || [];
      const newId = currentSets.length ? Math.max(...currentSets.map((s) => s.id)) + 1 : 1;
      const newSet = {
        id: newId,
        setCode: '',
        set_name: '',
        round_no: '',
        no_of_questions: 0,
        randomize_questions_within_set: false,
        set_picking_from: 0,
        set_picking_to: 0,
        scaled_score_adjustment: [{ no_of_qn_correct: 0, adjust_marks: '' }],
        questions: [],
      };
      currentSection.sets = [...currentSets, newSet];
      return { ...prevBody };
    });
  };

  // HANDLE REMOVE SET FUNCTION
  const handleRemoveSet = (idToRemove) => {
    setBody((prevBody) => {
      const currentSection = prevBody.groups[groupsButton].sections[sectionButton];
      let updatedSets = currentSection?.sets.filter((set) => set.id !== idToRemove);
      updatedSets = updatedSets.map((set, index) => ({ ...set, id: index + 1 }));
      currentSection.sets = updatedSets;
      return { ...prevBody };
    });
    setSelectedSetId((prevId) => {
      const sets = body.groups[groupsButton].sections[sectionButton].sets;
      return sets && sets.length ? sets[0].id : null;
    });
  };

  // HANDLE UPDATE FIELD FUNCTION
  const handleUpdateField = (field, value) => {
    setBody((prevBody) => {
      const currentSection = prevBody.groups[groupsButton].sections[sectionButton];
      currentSection.sets = currentSection.sets.map((set) => {
        if (set.id === selectedSetId) {
          if (field === 'no_of_questions') {
            if (Number(value) > 999) {
              toast?.remove('all');
              toast?.add('Enter no. of question from 1 to 999', 'error');
            }
            let noOfQuestions = Number(value) > 999 ? 999 : Number(Math.trunc(value));
            if (value !== '' && Number(value) <= 0) {
              noOfQuestions = 1;
            }
            if (value == '') {
              noOfQuestions = '';
            }
            return {
              ...set,
              no_of_questions: noOfQuestions,
              scaled_score_adjustment: Array.from({ length: noOfQuestions + 1 }, (_, i) => ({
                no_of_qn_correct: i,
                adjust_marks: '',
              })),
            };
          }
          if (field === 'set_picking_from' || field === 'set_picking_to' || field === 'round_no') {
            return {
              ...set,
              [field]: value === '' ? value : Number(value),
            };
          }
          return { ...set, [field]: value };
        }
        return set;
      });
      return { ...prevBody };
    });
  };

  // HANDLE UPDATE SCORE FUNCTION
  const handleUpdateScore = (index, value) => {
    let newValue = value;
    setBody((prevBody) => {
      const currentSection = prevBody.groups[groupsButton].sections[sectionButton];
      currentSection.sets = currentSection.sets.map((set) => {
        if (set.id === selectedSetId) {
          return {
            ...set,
            scaled_score_adjustment: set.scaled_score_adjustment.map((item, i) =>
              i === index ? { ...item, adjust_marks: newValue === '' ? newValue : Number(newValue) } : item
            ),
          };
        }
        return set;
      });
      return { ...prevBody };
    });
  };

  const onDragEndRows = (result) => {
    const { source, destination } = result;

    if (!destination || source.index === destination.index) return;

    let updatedQuestionsList = null;
    setBody((prevBody) => {
      const updatedBody = structuredClone(prevBody);
      const targetSet = updatedBody?.groups?.[groupsButton]?.sections?.[sectionButton]?.sets?.find(
        (set) => String(set.id) === String(selectedSetId)
      );

      if (!targetSet || !targetSet.questions) {
        console.error('Invalid set or no questions found.');
        return prevBody;
      }

      // Clone the questions array for the current set
      const reorderedQuestions = Array.from(targetSet.questions);
      // Perform the reorder based on the drag-and-drop indices
      const [moved] = reorderedQuestions.splice(source.index, 1);
      reorderedQuestions.splice(destination.index, 0, moved);
      // Create a new array with updated order values
      const updatedQuestions = reorderedQuestions.map((question, index) => ({
        ...question,
        order: index + 1,
      }));

      targetSet.questions = updatedQuestions;
      updatedQuestionsList = updatedQuestions;
      return updatedBody;
    });

    if (updatedQuestionsList) {
      setQuestionResults(updatedQuestionsList);
    }
  };

  // Helper: reorder function
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const onDragNestedGroupQuestions = (result) => {
    const { source, destination } = result;

    // Exit if there's no destination or if dropped at the same position
    if (!destination || (source.droppableId === destination.droppableId && source.index === destination.index)) {
      return;
    }
    const destinationIndex = result.destination.index;
    const currentQuestionId = result.draggableId.split('-')[result.draggableId.split('-').length - 1];
    const currentDraftId =
      result.destination.droppableId.split('-')[result.destination.droppableId.split('-').length - 1];

    let targetQuestions = null;
    setBody((prevBody) => {
      const updatedBody = structuredClone(prevBody);
      const targetSet = updatedBody?.groups?.[groupsButton]?.sections?.[sectionButton]?.sets?.find(
        (set) => String(set.id) === String(selectedSetId)
      );

      if (!targetSet || !targetSet.questions) return prevBody;

      const draftObj = targetSet.questions.find((item) => item.question_draft_id === Number(currentDraftId));
      if (!draftObj || !draftObj.questions) return prevBody;

      const questions = draftObj.questions;
      const currentIndex = questions.findIndex((q) => q.question_id === Number(currentQuestionId));
      if (currentIndex === -1 || destinationIndex < 0 || destinationIndex >= questions.length) return prevBody;

      const [movedQuestion] = questions.splice(currentIndex, 1);
      questions.splice(destinationIndex, 0, movedQuestion);

      questions.forEach((q, idx) => {
        q.order = idx + 1;
      });

      targetQuestions = targetSet.questions;
      return updatedBody;
    });

    if (targetQuestions) {
      setQuestionResults(targetQuestions);
    }
  };
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    // Handle section dragging
    if (source.droppableId === 'sections-droppable') {
      // Check if dragging within the same droppable area
      if (source.droppableId === destination.droppableId) {
        setBody((prevBody) => {
          const newGroups = prevBody.groups.map((group, idx) => {
            // Only update the current group based on groupsButton
            if (idx === groupsButton) {
              const reorderedSections = reorder(group.sections, source.index, destination.index);
              // Recalculate the order
              reorderedSections.forEach((section, idx) => {
                section.order = idx + 1;
              });

              return {
                ...group,
                sections: reorderedSections,
              };
            }
            return group;
          });
          return {
            ...prevBody,
            groups: newGroups,
          };
        });
        // If you maintain separate groups state, update that as well:
        setGroups((prevGroups) => {
          const updatedGroups = prevGroups.map((group, idx) => {
            if (idx === groupsButton) {
              const reorderedSections = reorder(group.sections, source.index, destination.index);
              return {
                ...group,
                sections: reorderedSections,
              };
            }
            return group;
          });
          return updatedGroups;
        });

        // Adjust sectionButton state if needed to track currently selected section
        if (source.index === sectionButton) {
          setSectionButton(destination.index);
        } else if (source.index < sectionButton && destination.index >= sectionButton) {
          setSectionButton(sectionButton - 1);
        } else if (source.index > sectionButton && destination.index <= sectionButton) {
          setSectionButton(sectionButton + 1);
        }
      }
    }
    // Handle top-level questions reordering
    else if (source.droppableId === 'rows-droppable') {
      onDragEndRows(result);
    } else if (result.type === 'nestedQuestion-droppable') {
      onDragNestedGroupQuestions(result);
    }
  };

  useEffect(() => {
    if (isInitialized) return;
    if (testDetails?.group_details[0]) {
      const newBody = {
        randomize_sections: testDetails?.group_details[0].randomize_sections,
        sections: testDetails?.group_details,
      };

      setBody({
        groups: [structuredClone(newBody)],
      });
      const initialGroups = [
        {
          id: 0,
          sections: structuredClone(testDetails?.group_details).map((elem, index) =>
            elem.sets?.map((set, index) => {
              return { ...set, id: index + 1 };
            })
          ),
        },
      ];

      setGroups(structuredClone(initialGroups));
      setBody((prevState) => {
        const updatedGroups = prevState.groups.map((group) => {
          // Map through the existing sections and update them based on testDetails?.group_details
          const updatedSections = testDetails?.group_details?.map((section, sectionIndex) => {
            // Map through the sets within the section and add the id
            const updatedSets = section?.sets?.map((set, setIndex) => ({
              ...set,
              id: setIndex + 1, // Assign id as index + 1
            }));

            return {
              ...section,
              sets: updatedSets, // Update the section's sets
            };
          });

          return {
            ...group,
            randomize_sections: testDetails?.group_details[0].randomize_sections,
            sections: updatedSections || group.sections, // Update the sections if group_details exists
          };
        });

        return { groups: structuredClone(updatedGroups) };
      });

      setQuestionApiRender(!questionApiRender);
      setIsInitialized(true);
    } else {
      if (onAdd && structuredClone(sectionBody).groups) {
        setBody(structuredClone(sectionBody));
        const initialGroups = structuredClone(sectionBody?.groups).map((group, index) => ({
          id: index,
          sections: structuredClone(group?.sections)
            .map((item) => item)
            .map((elem, index) =>
              elem.sets?.map((set, index) => {
                return { ...set, id: index + 1 };
              })
            ),
        }));

        setGroups(structuredClone(initialGroups));
        setIsInitialized(true);
      }
    }
  }, [testDetails, isInitialized]);
  function transformPayload(payload, id) {
    let quesOrder = 0;
    const returnTestID = (groupIndex, setIndex, question) => {
      const test = testDetails?.group_details[groupIndex]?.sets[setIndex]?.questions?.find(
        (item) => item?.question_id === question?.question_id
      );
      return test?.test_question_id ?? null;
    };
    //  const previousData=testDetails.group_details[0].sections[0].sets[0].questions
    return {
      groups: payload.groups.map((group, groupIndex) => ({
        randomize_sections: group.randomize_sections,
        sections: group.sections.map((section, sectionIndex) => ({
          group_id: section.group_id,
          randomize_sections: false,
          section_id: section.section_id,
          order: section.order,
          section_name: section.section_name,
          identifier: section.identifier,
          instructions: section.instructions.map((instruction) => ({
            instruction_id: instruction.instruction_id,
            has_timer: instruction.has_timer,
            minutes: instruction.minutes ?? 0,
            seconds: instruction.seconds ?? 0,
            instruction_text: instruction.instruction_text,
            section_id: section.section_id,
          })),
          no_of_rounds: section.no_of_rounds,
          initial_scale_score: section.initial_scale_score,
          min_score: section.min_score,
          max_score: section.max_score,
          unattempted_penalty: section.unattempted_penalty,
          sets: section.sets.map((set, setIndex) => ({
            set_id: set.set_id,
            section_id: section.section_id,
            set_name: set.set_name,
            round_no: set.round_no,
            no_of_questions: set.no_of_questions,
            randomize_questions_within_set: set.randomize_questions_within_set,
            set_picking_from: set.set_picking_from,
            set_picking_to: set.set_picking_to,
            scaled_score_adjustment: set.scaled_score_adjustment.map((adj) => ({
              adjust_marks: adj.adjust_marks.toString(),
              no_of_qn_correct: adj.no_of_qn_correct,
            })),
            questions: set?.questions[0]?.questions
              ? set?.questions?.flatMap((q, idx) =>
                  q?.questions?.map((question, index) => {
                    quesOrder++;
                    return {
                      test_question_id: returnTestID(groupIndex, setIndex, question)
                        ? returnTestID(groupIndex, setIndex, question)
                        : null,
                      order: quesOrder,
                      parent_order: idx + 1,
                      question_id: question.question_id,
                      unattempted_penalty: q.unattempted_penalty ?? section.unattempted_penalty,
                    };
                  })
                )
              : set?.questions?.map((q, idx) => {
                  return {
                    test_question_id: q.test_question_id,
                    order: q?.order,
                    question_id: q.question_id,
                    unattempted_penalty: q.unattempted_penalty,
                    parent_order: idx + 1,
                  };
                }),
          })),
        })),
      })),
    };
  }
  const updateSection = async () => {
    const testId = testDetails?.id ?? testCreationId;
    if (isEdit) {
      body.id = testDetails?.id;
    }
    if (onAdd && structuredClone(sectionBody).groups) {
      body.id = testCreationId;
    }

    const payload = transformPayload(body, testId);
    const url = isEdit
      ? `${CREATE_TESTS_SECTION}${testDetails?.id}/update_sections/`
      : onAdd && structuredClone(sectionBody).groups
        ? `${CREATE_TESTS_SECTION}${testCreationId}/update_sections/`
        : `${CREATE_TESTS_SECTION}${testCreationId}/add_sections/`;
    const data = await CallWithAuth(
      isEdit || (onAdd && structuredClone(sectionBody).groups) ? 'PATCH' : 'PATCH',
      url,
      payload
    );
    if (data.status && (data.res.status === 201 || data.res.status === 200)) {
      getData(testDetails?.id ?? testCreationId);
      toast?.add(data.res.data.message, 'success');
      const screen = 2;
      const response = data?.res?.data?.data;
      dispatch({ type: CREATE_TEST_SECTION_SUCCESS, screen, body });
    } else {
      toast?.add(data.res.data.error, 'error');
    }
  };

  const getRotation = (field) => {
    if (field === 'created_at') {
      // Handle 'created_at' specifically for upside-down rotation
      if (sortConfig.sort === '-created_at') return 'rotate(0deg)';
      if (sortConfig.sort === 'created_at') return 'rotate(180deg)';
    }
    if (sortConfig.field !== field) return 'rotate(0deg)';
    return sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
  };

  // Helper function to get icon color
  const getIconColor = (field) => {
    return sortConfig.field === field ? '#00ABFB' : '#999090';
  };

  const onConfirmDuplicate = (
    questionBankId,
    questionId,
    questionCategory = null, // Default to null or any appropriate value
    QuestionListing = () => Promise.resolve(true), // Default to a no-op function
    MyQuestionListing = () => Promise.resolve(true) // Default to a no-op function
  ) => {
    handleConfirmDuplicate(
      organizationId,
      questionBankId,
      questionId,
      setIsModalOpen,
      setIsPreviewopen,
      setIsDuplicatePreview,
      setactionId,
      toast,
      questionCategory,
      QuestionListing,
      MyQuestionListing
    );
  };

  const closeModal = () => {
    closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
  };

  // Function to handle opening the preview modal
  const handleOpenModal = (items) => {
    openPreviewModal(items, setSelectedQuestion, setIsPreviewopen);
  };

  const handleCloseModal = () => {
    closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
  };

  const handleEdit = async (items) => {
    await editQuestionHandler(items, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
  };

  const openModalMedium = () => {
    setModalMedium(true);
  };
  const closeModalMedium = () => {
    setModalMedium(false);
  };
  // Memoized serial numbers map directly derived from active questions list
  const serialNumbersMap = useMemo(() => {
    if (!body?.groups || groupsButton === undefined || sectionButton === undefined) return {};
    const currentSection = body.groups[groupsButton]?.sections?.[sectionButton];
    if (!currentSection?.sets) return {};

    const currentSet = currentSection.sets.find((set) => String(set.id) === String(selectedSetId));
    const questionSetList = currentSet?.questions || questionResults;
    if (!Array.isArray(questionSetList)) return {};

    const newSerialMap = {};
    let currentSerialNo = 1;

    // Loop through all questions in the current set
    questionSetList.forEach((item) => {
      if (Array.isArray(item?.questions) && item.questions.length > 0) {
        // Handle both grouped passage questions and single questions with questions array
        item.questions.forEach((q) => {
          const qId = q?.question_id ?? q?.id;
          if (qId !== undefined && qId !== null) {
            newSerialMap[qId] = currentSerialNo;
            newSerialMap[String(qId)] = currentSerialNo;
            newSerialMap[Number(qId)] = currentSerialNo;
            currentSerialNo++;
          }
        });
      } else {
        // Standalone question without nested questions array
        const qId = item?.question_id ?? item?.id;
        if (qId !== undefined && qId !== null) {
          newSerialMap[qId] = currentSerialNo;
          newSerialMap[String(qId)] = currentSerialNo;
          newSerialMap[Number(qId)] = currentSerialNo;
          currentSerialNo++;
        }
      }
    });

    return newSerialMap;
  }, [body, groupsButton, sectionButton, selectedSetId, questionResults]);

  // Function to get the serial number for a specific question, supporting positional index or ID fallback
  const getSerialNumber = (questionId, fallbackId, cardIndex, nestedIndex = 0) => {
    if (cardIndex !== undefined && cardIndex !== null) {
      const currentSection = body?.groups?.[groupsButton]?.sections?.[sectionButton];
      const currentSet = currentSection?.sets?.find((set) => String(set.id) === String(selectedSetId));
      const questionsList = currentSet?.questions || questionResults;
      if (Array.isArray(questionsList) && questionsList.length > 0) {
        let count = 1;
        for (let idx = 0; idx < cardIndex && idx < questionsList.length; idx++) {
          const qItem = questionsList[idx];
          count += Array.isArray(qItem?.questions) && qItem.questions.length > 0 ? qItem.questions.length : 1;
        }
        return count + nestedIndex;
      }
      return cardIndex + 1 + nestedIndex;
    }
    const id = questionId ?? fallbackId;
    if (id === undefined || id === null) return '-';
    return serialNumbersMap[id] !== undefined ? serialNumbersMap[id] : '-';
  };
  // const memoizedJSX = useMemo(
  //   () => (sectionItem) => (

  //   ),
  //   [] // Recreates function only when `count` changes
  // );
  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className={`${style.masterTestCreation} ${style.masterTestCreation_new} ${style.quasiSectionCreation}`}>
        <div className={`${style.testCreationArea} {style.testCreationArea_new}`}>
          <DragDropContext onDragEnd={handleDragEnd}>
            {body.groups
              .filter((item, key) => key === groupsButton)
              .map((items, i) => (
                <div key={i} className={style.section_form}>
                  {/* section buttons  */}
                  <Droppable droppableId="sections-droppable" direction="horizontal">
                    {(provided) => (
                      <div
                        className={`${style.sectionTestCreation}`}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        <div className={style.containGroup}>
                          {items.sections?.map((items, i) =>
                            !isView ? (
                              <Draggable key={i} draggableId={`section-${i}`} index={i}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div
                                      key={i}
                                      className={
                                        i === sectionButton
                                          ? ` ${style.multiquestionbutton} ${style.draggable}`
                                          : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                                      }
                                      onClick={() => {
                                        setSectionButton(i);
                                        setSelectedSetId(1);
                                        setRemoveId([]);
                                      }}
                                    >
                                      {i === sectionButton ? (
                                        <svg
                                          width="10"
                                          height="14"
                                          viewBox="0 0 10 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                            fill="white"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          width="10"
                                          height="14"
                                          viewBox="0 0 10 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                            fill="#272727"
                                          />
                                        </svg>
                                      )}{' '}
                                      &nbsp; Section {i + 1}
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ) : (
                              <div
                                key={i}
                                className={
                                  i === sectionButton
                                    ? ` ${style.multiquestionbutton}`
                                    : ` ${style.multiquestionbuttonBlue}`
                                }
                                onClick={() => {
                                  setSectionButton(i);
                                  setSelectedSetId(1);
                                }}
                              >
                                &nbsp; Section {i + 1}
                              </div>
                            )
                          )}
                          {provided.placeholder}
                        </div>

                        <div
                          className={`${style.icon_text} ${style.group_icon} ${isView ? style.isViewMainContainer : ''}`}
                        >
                          <p className={style.info}>Randomize Sections</p>
                          <div
                            style={{
                              border: '1px solid #3ebb5d',
                              height: '20px',
                              width: '20px',
                              borderRadius: '6px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              cursor: 'pointer',
                            }}
                            onClick={() => ChangeRandomize_Sections(!body.groups[groupsButton].randomize_sections)}
                          >
                            <div className={`${style.check_btn}`}>
                              {body.groups[groupsButton].randomize_sections ? (
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 23 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                    fill="url(#paint0_linear_1449_53208)"
                                  />
                                  <path
                                    d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_1449_53208"
                                      x1="22"
                                      y1="2"
                                      x2="7.89816"
                                      y2="18.4928"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#9BF763" />
                                      <stop offset="1" stopColor="#25AB5B" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Droppable>
                  {/* section add button  */}
                  {!isView && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
                      <button
                        className={`${style.addSetButton} ${style.threshold}`}
                        style={{ marginTop: '20px' }}
                        onClick={() => addSection(groups[groupsButton].id)}
                      >
                        {' '}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.5 12H16.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 16.5V7.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <h5 className={style.add_btn}>Add Section</h5>{' '}
                      </button>

                      {groupedSections.length > 1 && (onAdd || (isEdit && testDetails?.remove_sections)) && (
                        <button
                          className={`${style.removeGroupButton} ${style.section_remove}`}
                          onClick={() => deleteSection(groups[groupsButton].id, sectionButton)}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span style={{ marginLeft: '6px', fontSize: '12px' }}>Remove Section</span>
                        </button>
                      )}
                    </div>
                  )}
                  {items.sections
                    .filter((item, key) => key === sectionButton)
                    .map((sectionItem, sectionKey) => (
                      <div className={style.pageTwoSection} key={sectionKey}>
                        <div className={`${isView ? style.isViewMainContainer : ''}`}>
                          <div className={style.sectionHeading}>Section Details</div>
                          <div className={style.bound}>
                            <div className={`${style.templateDrop_item} ${style.sectionName}`}>
                              <div className={`${style.templateGroup}`}>
                                <span>Section Name </span>
                                <b className={style.red_mendantory}>*</b>
                                <input
                                  name="sectionName"
                                  id="sectionName"
                                  className={` ${style.score_drop_filter} ${style.verbalBox}`}
                                  placeholder="Enter section name"
                                  onChange={(e) => ChangeQuasiSectionName(e)}
                                  value={sectionItem.section_name}
                                />
                              </div>
                            </div>
                            {/* Test type */}
                            <div className={`${style.templateDrop} ${style.sectionIdentifier}`}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup}>
                                  <span>Section Identifier </span>
                                  <b className={style.red_mendantory}>*</b>
                                  <select
                                    name="identifier"
                                    id="identifier"
                                    style={{
                                      color:
                                        sectionItem?.identifier || sectionItem?.identifier === 0 ? 'black' : '#8E9EAB',
                                    }}
                                    value={
                                      sectionItem?.identifier === null
                                        ? 'Select Section Identifier'
                                        : sectionItem?.identifier
                                    }
                                    onChange={(e) => ChangeSectionIdentifier(e)}
                                    className={` ${style.template_drop_filter} ${style.varc}`}
                                  >
                                    <option value={null}>Select Section Identifier</option>
                                    {Array.isArray(identifierList) &&
                                      identifierList?.map((items, i) => (
                                        <option key={i + items.name} value={items?.id}>
                                          {items?.name}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={style.sectionInstruction}>
                            <div className={style.sectionHeading}>Section Instructions</div>
                            <p className={style.info}>Add instructions to appear before the section commences</p>
                            {sectionItem.instructions.map((instruction, instructionIndex) => (
                              <div key={instructionIndex} className={style.screenNum}>
                                <p style={{ fontWeight: 500 }}>Screen {instructionIndex + 1}</p>
                                <div className={style.icon_text}>
                                  <label className="custom-checkbox" aria-label="Has Timer">
                                    <input
                                      type="checkbox"
                                      checked={Boolean(instruction.has_timer)}
                                      onChange={(e) => handleTimerChange(e, sectionKey, instructionIndex, 'has_timer')}
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                  <p className={style.info}>Instruction Screen has a timer</p>
                                </div>

                                <div>
                                  {instruction.has_timer && (
                                    <div className={style.sectionTimer}>
                                      <p className={style.marketLogic}>Instruction Timer</p>
                                      <div className={`${style.timer} ${style.instrTimer}`}>
                                        <input
                                          onKeyDown={(e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                              e.preventDefault();
                                            }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          autoComplete="off"
                                          className={style.timer_input}
                                          type="number"
                                          name="minutes"
                                          min="0"
                                          max="100"
                                          step="1"
                                          value={instruction.minutes ?? ''}
                                          onChange={(e) =>
                                            handleTimerChange(e, sectionKey, instructionIndex, 'minutes')
                                          }
                                        />
                                        <label htmlFor="minutes" style={{ marginRight: '18px' }}>
                                          Minutes
                                        </label>
                                        <input
                                          onKeyDown={(e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                              e.preventDefault();
                                            }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          autoComplete="off"
                                          className={style.timer_input}
                                          type="number"
                                          name="seconds"
                                          min="0"
                                          max="100"
                                          step="1"
                                          value={instruction.seconds ?? ''}
                                          onChange={(e) =>
                                            handleTimerChange(e, sectionKey, instructionIndex, 'seconds')
                                          }
                                        />
                                        <label htmlFor="seconds">Seconds</label>
                                      </div>
                                    </div>
                                  )}
                                  <p className={style.marketLogic}>Section Instructions</p>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', width: '84%' }}>
                                    <div style={{ height: 'auto', flexGrow: '1' }}>
                                      <QuillEditor
                                        defaultValue={decodeBase64(instruction.instruction_text)}
                                        disabled={isView}
                                        onChange={(content) =>
                                          handleInstructionTextChange(content, sectionKey, instructionIndex)
                                        }
                                      />
                                    </div>
                                    {instructionIndex !== 0 && (
                                      <button
                                        type="button"
                                        className={style.penaltyDelete}
                                        onClick={() => removeScreen(sectionKey, instructionIndex)}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                            stroke="#272727"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                            stroke="#272727"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                            stroke="#272727"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                            {!isView && (
                              <button
                                onClick={() => addScreen(sectionKey)}
                                className={`${style.addSetButton} ${style.threshold} ${style.addInstrButton}`}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 12H16.5"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12 16.5V7.5"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <h5 className={style.add_btn}>Add Instruction Screen</h5>
                              </button>
                            )}
                          </div>
                          <div className={style.sectionRoundInfo}>
                            <div className={style.sectionTemplateRoundInfo}>
                              <div className={style.templateDrop}>
                                <div className={style.templateDrop_item}>
                                  <div className={style.templateGroup}>
                                    <span>No. of Rounds </span>
                                    <b className={style.red_mendantory}>*</b>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="number"
                                      name="round"
                                      id="round"
                                      min={1}
                                      max={999}
                                      className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                      placeholder="Enter no. of rounds"
                                      onChange={(e) => ChangeNoOfRound(e)}
                                      value={sectionItem.no_of_rounds}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.templateDrop}>
                                <div className={style.templateDrop_item}>
                                  <div className={style.templateGroup}>
                                    <span>Initial Scaled Score </span>
                                    <b className={style.red_mendantory}>*</b>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="number"
                                      name="initialScore"
                                      id="initialScore"
                                      className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                      placeholder="Enter initial scaled score"
                                      onChange={(e) => ChangeInitialScore(e)}
                                      value={sectionItem.initial_scale_score}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.templateDrop}>
                                <div className={style.templateDrop_item}>
                                  <div className={style.templateGroup}>
                                    <span>Highest Score </span>
                                    <b className={style.red_mendantory}>*</b>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="number"
                                      name="highestScore"
                                      id="highestScore"
                                      className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                      placeholder="Enter highest score"
                                      onChange={(e) => ChangeHighestScore(e)}
                                      value={sectionItem.max_score}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.templateDrop}>
                                <div className={style.templateDrop_item}>
                                  <div className={style.templateGroup}>
                                    <span>Lowest Score </span>
                                    <b className={style.red_mendantory}>*</b>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="number"
                                      name="lowestScore"
                                      id="lowestScore"
                                      className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                      placeholder="Enter lowest score"
                                      onChange={(e) => ChangeLowestScore(e)}
                                      value={sectionItem.min_score}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={style.bound}>
                              <div className={style.templateDrop}>
                                <div className={style.templateDrop_item}>
                                  <div className={style.templateGroup}>
                                    <span>Unattempted Penalty </span>
                                    <b className={style.red_mendantory}>*</b>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="number"
                                      name="penalty"
                                      disabled={disableMarking}
                                      id="penalty"
                                      className={` ${style.score_drop_filter} ${style.fullBgmarks} ${style.unattempled_penalty}`}
                                      placeholder=""
                                      onChange={(e) => changeUnattemptedPenalty(e)}
                                      value={body.groups[groupsButton].sections[sectionButton]?.unattempted_penalty}
                                    />
                                  </div>
                                </div>
                              </div>
                              {!isView && (
                                <div>
                                  {disableMarking ? (
                                    <button
                                      onClick={() => setDisableMarking(false)}
                                      style={{ cursor: 'pointer' }}
                                      className={`${style.check_btn} ${style.threshold}`}
                                    >
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3 22H21"
                                          stroke="#00ABFB"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                                          stroke="#00ABFB"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                                          stroke="#00ABFB"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <h5>Edit</h5>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => setDisableMarking(true)}
                                      style={{ cursor: 'pointer' }}
                                      className={`${style.threshold} ${style.editInput}`}
                                    >
                                      <h5>Done</h5>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                          fill="url(#paint0_linear_1449_53208)"
                                        />
                                        <path
                                          d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <defs>
                                          <linearGradient
                                            id="paint0_linear_1449_53208"
                                            x1="22"
                                            y1="2"
                                            x2="7.89816"
                                            y2="18.4928"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            <stop stopColor="#00ABFB" />
                                            <stop offset="1" stopColor="#00ABFB" />
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div style={{ paddingLeft: '5px' }}>
                          <div className={`${style.sectionSetsLeft}`}>
                            {sectionItem.sets.map((set, index) => (
                              <button
                                key={set.id}
                                className={`${selectedSetId === set.id ? style.multiquestionbutton : style.multiquestionbuttonBlue}`}
                                onClick={() => {
                                  setSelectedSetId(set.id);
                                  setRemoveId([]);
                                }}
                              >
                                Set {set.id}
                              </button>
                            ))}
                          </div>
                          {!isView && (
                            <div
                              className={`${style.addSetContainer}`}
                              style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                              <button
                                className={`${style.addSetButton} ${style.threshold}`}
                                onClick={handleAddSet}
                                style={{ marginTop: '0px' }}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 12H16.5"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12 16.5V7.5"
                                    stroke="#00ABFB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <h5 className={`${style.addSetText} ${style.add_btn}`} style={{ marginTop: '0px' }}>
                                  Add Set
                                </h5>
                              </button>
                              {sectionItem.sets.length > 1 && (onAdd || (isEdit && testDetails?.remove_set)) && (
                                <div className={style.removeSet}>
                                  <button
                                    className={`${style.removeGroupButton}`}
                                    onClick={() => handleRemoveSet(selectedSetId)}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                        stroke="#272727"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                        stroke="#272727"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                        stroke="#272727"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span style={{ marginLeft: '6px' }}>Remove Set</span>
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className={`${style.sectionSets}`}>
                          <div className={`${style.sectionSetsRight}`}>
                            <h5
                              style={{ marginTop: '0px', fontSize: '18px' }}
                              className={isView ? style.detailsConfigureSet : ''}
                            >
                              Configure Sets
                            </h5>
                            {selectedSetId ? (
                              <div>
                                <div className={`${isView ? style.isViewMainContainer : ''}`}>
                                  <div className={style.setNameSection}>
                                    <div className={style.fieldGroup} style={{ width: '38%' }}>
                                      <label htmlFor="setCode">
                                        Set Code <b className={style.red_mendantory}>*</b>
                                      </label>
                                      <input
                                        type="text"
                                        id="setCode"
                                        placeholder="Enter set code"
                                        style={{ width: '91%' }}
                                        value={sectionItem.sets.find((set) => set.id === selectedSetId)?.set_name || ''}
                                        onChange={(e) => handleUpdateField('set_name', e.target.value)}
                                      />
                                    </div>
                                    <div className={style.fieldGroup} style={{ maxWidth: '60%' }}>
                                      <label htmlFor="setName">
                                        <span>Set Name</span>
                                        <span className={style.iconWrapper}>
                                          <img
                                            src={infoIcon}
                                            className={style.iconInfo}
                                            alt="infoicon"
                                            onMouseEnter={() => setShowPopup(true)}
                                            onMouseLeave={() => setShowPopup(false)}
                                            style={{ pointerEvents: 'all' }}
                                          />
                                          {showPopup && (
                                            <div className={style.popup}>
                                              <span>Set Name is displayed based on the following format:</span>
                                              <div style={{ fontWeight: '600' }}>
                                                {' '}
                                                Section Name | Round No. | Set Code
                                              </div>
                                            </div>
                                          )}
                                        </span>
                                      </label>
                                      <div style={{ width: '100%', wordWrap: 'break-word' }}>
                                        {(sectionItem.section_name ||
                                          sectionItem.sets.find((set) => set.id === selectedSetId)?.round_no ||
                                          sectionItem.sets.find((set) => set.id === selectedSetId)?.set_name) && (
                                          <div className={style.setcode_info}>
                                            {sectionItem.section_name ? sectionItem.section_name : ''}{' '}
                                            {sectionItem.sets.find((set) => set.id === selectedSetId)?.round_no
                                              ? ' | R: ' +
                                                sectionItem.sets.find((set) => set.id === selectedSetId)?.round_no
                                              : ''}{' '}
                                            {sectionItem.sets.find((set) => set.id === selectedSetId)?.set_name
                                              ? ' | S: ' +
                                                sectionItem.sets.find((set) => set.id === selectedSetId)?.set_name
                                              : ''}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className={style.fieldGroup}>
                                    <label htmlFor="roundNo">
                                      Round No. <b className={style.red_mendantory}>*</b>
                                    </label>
                                    <select
                                      id="roundNo"
                                      className={`${style.score_drop_filter} ${style.fullBgmarks}`}
                                      onChange={(e) => handleUpdateField('round_no', e.target.value)}
                                      style={{
                                        height: '50px',
                                        color: sectionItem.sets.find((set) => set.id === selectedSetId)?.round_no
                                          ? 'black'
                                          : '#8E9EAB',
                                      }}
                                      // Assuming you want to default to the current round_no value or empty
                                      value={sectionItem.sets.find((set) => set.id === selectedSetId)?.round_no || ''}
                                    >
                                      <option value="">Select round no.</option>
                                      {/* Generate options from 1 up to maxRounds */}
                                      {Array.from({ length: Number(sectionItem.no_of_rounds) }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className={style.setNameSection}>
                                    <div className={style.fieldGroup}>
                                      <label htmlFor="noOfQuestions">
                                        No. of Questions <b className={style.red_mendantory}>*</b>
                                      </label>
                                      <input
                                        onKeyDown={(e) => {
                                          if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                            event.preventDefault();
                                          }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        type="number"
                                        id="noOfQuestions"
                                        value={
                                          sectionItem.sets.find((set) => set.id === selectedSetId)?.no_of_questions ??
                                          ''
                                        }
                                        min={1}
                                        max={999}
                                        onChange={(e) => handleUpdateField('no_of_questions', e.target.value)}
                                      />
                                    </div>
                                    <div className={style.fieldGroup}>
                                      <label htmlFor="randomizeQuestionsYes">Randomize Questions</label>
                                      <div className={`${style.randmizeQue} ${style.custom_input_container}`}>
                                        <input
                                          type="radio"
                                          id="randomizeQuestionsYes"
                                          className={style.custom_radio}
                                          checked={
                                            sectionItem.sets.find((set) => set.id === selectedSetId)
                                              ?.randomize_questions_within_set
                                          }
                                          onChange={() => handleUpdateField('randomize_questions_within_set', true)}
                                        />{' '}
                                        <label htmlFor="randomizeQuestionsYes">Yes</label>
                                        <input
                                          type="radio"
                                          id="randomizeQuestionsNo"
                                          className={style.custom_radio}
                                          checked={
                                            !sectionItem.sets.find((set) => set.id === selectedSetId)
                                              ?.randomize_questions_within_set
                                          }
                                          onChange={() => handleUpdateField('randomize_questions_within_set', false)}
                                        />{' '}
                                        <label htmlFor="randomizeQuestionsNo">No</label>
                                      </div>
                                    </div>
                                  </div>
                                  <h5 style={{ marginTop: '5px', marginBottom: '12px', fontSize: '16px' }}>
                                    Set Picking Range <b className={style.red_mendantory}>*</b>
                                  </h5>
                                  <div className={style.setNameSection}>
                                    <div className={style.fieldGroup}>
                                      <label htmlFor="inputRangeStart">
                                        Input Range Start <b className={style.red_mendantory}>*</b>
                                      </label>
                                      <input
                                        onKeyDown={(e) => {
                                          if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                            event.preventDefault();
                                          }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        type="number"
                                        id="inputRangeStart"
                                        placeholder="Input +/- mark"
                                        value={
                                          sectionItem.sets.find((set) => set.id === selectedSetId)?.set_picking_from ??
                                          ''
                                        }
                                        onChange={(e) => handleUpdateField('set_picking_from', e.target.value)}
                                      />
                                    </div>
                                    <div className={style.fieldGroup}>
                                      <label htmlFor="inputRangeEnd">
                                        Input Range End <b className={style.red_mendantory}>*</b>
                                      </label>
                                      <input
                                        onKeyDown={(e) => {
                                          if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                            event.preventDefault();
                                          }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        type="number"
                                        id="inputRangeEnd"
                                        placeholder="Input +/- mark"
                                        value={
                                          sectionItem.sets.find((set) => set.id === selectedSetId)?.set_picking_to ?? ''
                                        }
                                        onChange={(e) => handleUpdateField('set_picking_to', e.target.value)}
                                      />
                                    </div>
                                  </div>
                                  {sectionItem.sets.find((set) => set.id === selectedSetId)?.no_of_questions > 0 && (
                                    <div className={style.scoreTable}>
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Number Of Questions Correct</th>
                                            <th>
                                              Score +/- To Section Initial Scaled Score{' '}
                                              <b className={style.red_mendantory}>*</b>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {sectionItem.sets
                                            .find((set) => set.id === selectedSetId)
                                            ?.scaled_score_adjustment.map((score, index) => (
                                              <tr key={index + 1}>
                                                <td>{index}</td>
                                                <td>
                                                  <input
                                                    onKeyDown={(e) => {
                                                      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    autoComplete="off"
                                                    type="number"
                                                    disabled={isView}
                                                    value={score.adjust_marks ?? ''}
                                                    onChange={(e) => handleUpdateScore(index, e.target.value)}
                                                    style={{ textAlign: 'center', width: '100%' }}
                                                    placeholder="Input +/- mark(s)"
                                                  />
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </div>
                                {/* question list  */}
                                {sectionItem?.sets.find((set) => set.id === selectedSetId)?.questions.length === 0 ? (
                                  <div className={style.ruleContainer}>
                                    <h2 className={style.title}>No Questions Added!</h2>
                                    <p className={style.description}>
                                      Please click “Add questions from question bank” button to proceed.
                                    </p>
                                    <button
                                      className={`${style.addNewQuestionBt} ${style.addNewQuestionBank_new} `}
                                      onClick={() => AddQuestionFromBank()}
                                      style={{ visibility: isView ? 'hidden' : 'visible' }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.16797 10H18.168"
                                          stroke="#00ABFB"
                                          strokeWidth="3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M10.168 18V2"
                                          stroke="#00ABFB"
                                          strokeWidth="3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <span> Add questions from question bank</span>
                                    </button>
                                  </div>
                                ) : (
                                  <div className={style.questionBankCard}>
                                    <div className={`${isView ? style.isViewMainContainer : ''}`}>
                                      <div className={`${style.headerBank} ${style.headerBank_new}`}>
                                        <h4
                                          id="questionId3456"
                                          style={{ fontWeight: '500', fontSize: '18px' }}
                                          className={style.questionListLabel}
                                        >
                                          Question List
                                        </h4>
                                        <button
                                          className={`${style.addNewQuestionBt} ${style.addNewQuestionBank} `}
                                          onClick={() => AddQuestionFromBank()}
                                          style={{ visibility: isView ? 'hidden' : 'visible' }}
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M2.16797 10H18.168"
                                              stroke="#00ABFB"
                                              strokeWidth="3"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M10.168 18V2"
                                              stroke="#00ABFB"
                                              strokeWidth="3"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                          <span> Add questions from question bank</span>
                                        </button>
                                      </div>
                                      <div className={style.handleAttempt}>
                                        <span>
                                          {' '}
                                          {/* {removeId.length??0} */}
                                          {sectionItem?.sets?.find((set) => String(set.id) === String(selectedSetId))
                                            ? sectionItem?.sets
                                                ?.find((set) => String(set.id) === String(selectedSetId))
                                                ?.questions?.reduce(
                                                  (count, q) => count + (q?.questions?.length || 0),
                                                  0
                                                )
                                            : ''}
                                        </span>
                                        <span style={{ color: 'lightgray' }}>
                                          /{' '}
                                          {
                                            sectionItem?.sets?.find((set) => String(set.id) === String(selectedSetId))
                                              ?.no_of_questions
                                          }
                                        </span>
                                        <span> selected</span>
                                      </div>
                                    </div>
                                    <Droppable droppableId="rows-droppable">
                                      {(provided) => (
                                        <div
                                          ref={provided.innerRef}
                                          {...provided.droppableProps}
                                          className={`${style.cardsGrid} ${isView ? style.isViewMainContainer : ''}`}
                                        >
                                          {sectionItem?.sets
                                            ?.find((set) => String(set.id) === String(selectedSetId))
                                            ?.questions?.map((item, i) => (
                                              <Draggable
                                                key={item.question_draft_id || item.question_id}
                                                draggableId={`row-${item.question_draft_id || item.question_id}`}
                                                index={i}
                                              >
                                                {(provided, snapshot) => (
                                                  <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`${style.questionCard} ${
                                                      style.questionCard_new
                                                    } ${snapshot.isDragging ? style.dragging : ''}`}
                                                    style={{
                                                      ...provided.draggableProps.style,
                                                      background: snapshot.isDragging ? '#f0f0f0' : 'white',
                                                    }}
                                                  >
                                                    {/* Header for grouped questions */}
                                                    {item?.format === 1 && item?.passage_name && (
                                                      <div className={style.GroupHeaderWrap}>
                                                        <div className={style.passageHeader}>
                                                          <span>{item.passage_name}</span>
                                                        </div>
                                                        <div
                                                          className={`${style.colapseIconwrap} ${
                                                            collapse[item.question_draft_id || item.question_id]
                                                              ? style.colapseIconRotated
                                                              : ''
                                                          }`}
                                                          onClick={() =>
                                                            toggleCollapse(item.question_draft_id || item.question_id)
                                                          }
                                                        >
                                                          <img
                                                            src={colapseIcon}
                                                            className={style.colapseIcon}
                                                            alt="colapseIcon"
                                                          />
                                                        </div>
                                                      </div>
                                                    )}

                                                    {item.format === 1 && item.passage_name !== null && (
                                                      <img
                                                        src={passageVerticalLineSvg}
                                                        className={`${style.PassageVertical_line} ${style.questionContent} ${
                                                          collapse[item.question_draft_id || item.question_id]
                                                            ? style.questionContentCollapsed
                                                            : style.questionContentExpanded
                                                        }`}
                                                        alt="Vertical Line"
                                                      />
                                                    )}
                                                    <div
                                                      className={`${style.questionContent} ${
                                                        collapse[item.question_draft_id || item.question_id]
                                                          ? style.questionContentCollapsed
                                                          : style.questionContentExpanded
                                                      }`}
                                                    >
                                                      {item?.format === 1 && item?.questions?.length > 0 ? (
                                                        <Droppable
                                                          droppableId={`nestedQuestion-droppable-${item.question_draft_id || item.question_id}`}
                                                          type="nestedQuestion-droppable"
                                                          isDropDisabled={false}
                                                        >
                                                          {(nestedProvided) => (
                                                            <div
                                                              ref={nestedProvided.innerRef}
                                                              {...nestedProvided.droppableProps}
                                                              className={style.nestedQuestionsContainer}
                                                            >
                                                              {item?.questions?.map((items, nestedIndex) => (
                                                                // {item?.format === 1 &&
                                                                //   item?.questions?.map((items) => (

                                                                <Draggable
                                                                  key={items.question_id}
                                                                  draggableId={`nested-${items.question_id}`}
                                                                  index={nestedIndex}
                                                                  isDragDisabled={false}
                                                                >
                                                                  {(nestedDragProvided, nestedSnapshot) => (
                                                                    <div
                                                                      ref={nestedDragProvided.innerRef}
                                                                      {...nestedDragProvided.draggableProps}
                                                                      {...nestedDragProvided.dragHandleProps}
                                                                      className={`${style.nestedQuestionCard} ${
                                                                        nestedSnapshot.isDragging ? style.dragging : ''
                                                                      }`}
                                                                    >
                                                                      <>
                                                                        <div className={style.cardHeader}>
                                                                          <div className={style.cardLeft}>
                                                                            <div className={style.serialNoWrap}>
                                                                              <span>
                                                                                {getSerialNumber(
                                                                                  items.question_id,
                                                                                  items.id,
                                                                                  i,
                                                                                  nestedIndex
                                                                                )}
                                                                              </span>
                                                                            </div>
                                                                            {!isView ? (
                                                                              <svg
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 20 20"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                              >
                                                                                <path
                                                                                  d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                                                                  fill="#272727"
                                                                                />
                                                                              </svg>
                                                                            ) : (
                                                                              ''
                                                                            )}
                                                                            <div className={style.changeCheckBox}>
                                                                              <label
                                                                                className="custom-checkbox"
                                                                                aria-label="checkbox"
                                                                              >
                                                                                <input
                                                                                  type="checkbox"
                                                                                  checked={removeId?.includes(
                                                                                    items.question_id
                                                                                  )}
                                                                                  onChange={(e) => {
                                                                                    setMarkingState([
                                                                                      ...markingState,
                                                                                      item,
                                                                                    ]);
                                                                                    RemoveIds(items, e.target.checked);
                                                                                  }}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                              </label>
                                                                            </div>

                                                                            <div
                                                                              className={style.questionId}
                                                                              onClick={() => {
                                                                                setBankId(items.question_bank);
                                                                                handleOpenModal(items.question_id);
                                                                              }}
                                                                            >
                                                                              <span className={style.questionNumber}>
                                                                                ID:
                                                                              </span>
                                                                              {items.question_id}
                                                                            </div>
                                                                          </div>
                                                                          <div className={style.cardRight}>
                                                                            <div className={style.quasiListScore}>
                                                                              <input
                                                                                onKeyDown={(e) => {
                                                                                  if (
                                                                                    event.key === 'ArrowUp' ||
                                                                                    event.key === 'ArrowDown'
                                                                                  ) {
                                                                                    event.preventDefault();
                                                                                  }
                                                                                }}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                autoComplete="off"
                                                                                type="number"
                                                                                value={
                                                                                  items.unattempted_penalty ??
                                                                                  sectionItem?.unattempted_penalty
                                                                                }
                                                                                disabled
                                                                                className={style.scoreInput}
                                                                              />
                                                                            </div>

                                                                            {!isView &&
                                                                              (onAdd ||
                                                                                (isEdit &&
                                                                                  testDetails?.delete_question)) && (
                                                                                <div
                                                                                  className={style.quasiReplaceIcon}
                                                                                  onClick={(e) => GetReplace(e, items)}
                                                                                >
                                                                                  <img
                                                                                    src={quasiReplace}
                                                                                    className={style.iconInfo}
                                                                                    style={{ margin: '0 8px' }}
                                                                                    alt="edit"
                                                                                  />
                                                                                </div>
                                                                              )}
                                                                            {!isView &&
                                                                              (onAdd ||
                                                                                (isEdit &&
                                                                                  testDetails?.delete_question)) && (
                                                                                <div
                                                                                  className={style.quasiDeleteIcon}
                                                                                  onClick={(e) => {
                                                                                    GetDelete(e, items);
                                                                                    //removeQueIds(e, items);
                                                                                  }}
                                                                                >
                                                                                  <img
                                                                                    src={quasiDelete}
                                                                                    className={style.iconInfo}
                                                                                    style={{ margin: '0 8px' }}
                                                                                    alt="delete"
                                                                                  />
                                                                                </div>
                                                                              )}
                                                                          </div>
                                                                        </div>
                                                                        <div className={style.cardBody}>
                                                                          <div className={style.tags}>
                                                                            <span className={style.primaryTag}>
                                                                              {items?.primary_tag?.slug}
                                                                            </span>
                                                                            {items?.free_tags
                                                                              ?.slice(0, 2)
                                                                              .map((tag, i) => (
                                                                                <span key={i} className={style.freeTag}>
                                                                                  {tag.name}
                                                                                </span>
                                                                              ))}
                                                                            {items?.free_tags?.length > 2 && (
                                                                              <span className={style.moreTags}>
                                                                                +{items?.free_tags?.length - 2}
                                                                              </span>
                                                                            )}
                                                                          </div>
                                                                          <div className={style.questionIdentifier}>
                                                                            <span className={style.shortIdentifier}>
                                                                              {items?.question_short_identifier}
                                                                            </span>
                                                                          </div>
                                                                          {/* FreeTags Section */}
                                                                          <div
                                                                            className={`${style.general_tag} ${style.quasiGeneralTags}`}
                                                                          >
                                                                            {items?.free_tags?.map((item, i) => (
                                                                              <button
                                                                                key={i}
                                                                                className={`${style.general_button} ${style.generalButtonWrap}`}
                                                                              >
                                                                                {item.name}
                                                                              </button>
                                                                            ))}
                                                                          </div>
                                                                          <div className={style.Quasimetadata}>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowAuthor}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                Author:
                                                                              </span>
                                                                              <span
                                                                                className={style.metaValue}
                                                                                style={{
                                                                                  whiteSpace: 'normal',
                                                                                  overflowWrap: 'break-word',
                                                                                  maxWidth: '100%',
                                                                                }}
                                                                              >
                                                                                {items.created_by}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowYear}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                Academic Year:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {items.academic_year}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowCreatedOn}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                Created On:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {moment(items.created_at).format(
                                                                                  'Do MMM YYYY'
                                                                                )}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowType}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                Type:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {items.type}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowLOD}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                LOD:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {items.difficulty}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowPvalue}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                P-value:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {items?.pvalue ?? '-'}
                                                                              </span>
                                                                            </div>
                                                                            <div
                                                                              className={`${style.metaRow} ${style.QuasimetaRowTestAttempt}`}
                                                                            >
                                                                              <span className={style.metaLabel}>
                                                                                Test Attempts:
                                                                              </span>
                                                                              <span className={style.metaValue}>
                                                                                {items?.test_attempts ?? '-'}
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </>
                                                                    </div>
                                                                  )}
                                                                </Draggable>
                                                              ))}

                                                              {nestedProvided.placeholder}
                                                            </div>
                                                          )}
                                                        </Droppable>
                                                      ) : (
                                                        (Array.isArray(item?.questions) && item.questions.length > 0
                                                          ? item.questions
                                                          : [item]
                                                        )?.map((items, nestedIndex) => (
                                                          <>
                                                            <div className={style.cardHeader}>
                                                              <div className={style.cardLeft}>
                                                                <div className={style.serialNoWrap}>
                                                                  <span>
                                                                    {getSerialNumber(
                                                                      items.question_id,
                                                                      items.id,
                                                                      i,
                                                                      nestedIndex
                                                                    )}
                                                                  </span>
                                                                </div>
                                                                {!isView ? (
                                                                  <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                  >
                                                                    <path
                                                                      d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                                                      fill="#272727"
                                                                    />
                                                                  </svg>
                                                                ) : (
                                                                  ''
                                                                )}
                                                                <div className={style.changeCheckBox}>
                                                                  <label
                                                                    className="custom-checkbox"
                                                                    aria-label="checkbox"
                                                                  >
                                                                    <input
                                                                      type="checkbox"
                                                                      checked={removeId?.includes(items.question_id)}
                                                                      onChange={(e) => {
                                                                        setMarkingState([...markingState, item]);
                                                                        RemoveIds(items, e.target.checked);
                                                                      }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                  </label>
                                                                </div>

                                                                <div
                                                                  className={style.questionId}
                                                                  onClick={() => {
                                                                    setBankId(items.question_bank);
                                                                    handleOpenModal(items.question_id);
                                                                  }}
                                                                >
                                                                  <span className={style.questionNumber}>ID:</span>
                                                                  {items.question_id}
                                                                </div>
                                                              </div>
                                                              <div className={style.cardRight}>
                                                                <div className={style.quasiListScore}>
                                                                  <input
                                                                    onKeyDown={(e) => {
                                                                      if (
                                                                        event.key === 'ArrowUp' ||
                                                                        event.key === 'ArrowDown'
                                                                      ) {
                                                                        event.preventDefault();
                                                                      }
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    autoComplete="off"
                                                                    type="number"
                                                                    value={
                                                                      items.unattempted_penalty ??
                                                                      sectionItem?.unattempted_penalty
                                                                    }
                                                                    disabled
                                                                    className={style.scoreInput}
                                                                  />
                                                                </div>

                                                                {!isView &&
                                                                  (onAdd ||
                                                                    (isEdit && testDetails?.delete_question)) && (
                                                                    <div
                                                                      className={style.quasiReplaceIcon}
                                                                      onClick={(e) => GetReplace(e, items)}
                                                                    >
                                                                      <img
                                                                        src={quasiReplace}
                                                                        className={style.iconInfo}
                                                                        style={{ margin: '0 8px' }}
                                                                        alt="edit"
                                                                      />
                                                                    </div>
                                                                  )}
                                                                {!isView &&
                                                                  (onAdd ||
                                                                    (isEdit && testDetails?.delete_question)) && (
                                                                    <div
                                                                      className={style.quasiDeleteIcon}
                                                                      onClick={(e) => {
                                                                        GetDelete(e, items);
                                                                        //removeQueIds(e, items);
                                                                      }}
                                                                    >
                                                                      <img
                                                                        src={quasiDelete}
                                                                        className={style.iconInfo}
                                                                        style={{ margin: '0 8px' }}
                                                                        alt="delete"
                                                                      />
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            </div>
                                                            <div className={style.cardBody}>
                                                              <div className={style.tags}>
                                                                <span className={style.primaryTag}>
                                                                  {items?.primary_tag?.slug}
                                                                </span>
                                                                {items?.free_tags?.slice(0, 2).map((tag, i) => (
                                                                  <span key={i} className={style.freeTag}>
                                                                    {tag.name}
                                                                  </span>
                                                                ))}
                                                                {items?.free_tags?.length > 2 && (
                                                                  <span className={style.moreTags}>
                                                                    +{items?.free_tags?.length - 2}
                                                                  </span>
                                                                )}
                                                              </div>
                                                              <div className={style.questionIdentifier}>
                                                                <span className={style.shortIdentifier}>
                                                                  {items?.question_short_identifier}
                                                                </span>
                                                              </div>
                                                              {/* FreeTags Section */}
                                                              <div
                                                                className={`${style.general_tag} ${style.quasiGeneralTags}`}
                                                              >
                                                                {items?.free_tags?.map((item, i) => (
                                                                  <button
                                                                    key={i}
                                                                    className={`${style.general_button} ${style.generalButtonWrap}`}
                                                                  >
                                                                    {item.name}
                                                                  </button>
                                                                ))}
                                                              </div>
                                                              <div className={style.Quasimetadata}>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowAuthor}`}
                                                                >
                                                                  <span className={style.metaLabel}>Author:</span>
                                                                  <span
                                                                    className={style.metaValue}
                                                                    style={{
                                                                      whiteSpace: 'normal',
                                                                      overflowWrap: 'break-word',
                                                                      maxWidth: '100%',
                                                                    }}
                                                                  >
                                                                    {items.created_by}
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowYear}`}
                                                                >
                                                                  <span className={style.metaLabel}>
                                                                    Academic Year:
                                                                  </span>
                                                                  <span className={style.metaValue}>
                                                                    {items.academic_year}
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowCreatedOn}`}
                                                                >
                                                                  <span className={style.metaLabel}>Created On:</span>
                                                                  <span className={style.metaValue}>
                                                                    {moment(items.created_at).format('Do MMM YYYY')}
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowType}`}
                                                                >
                                                                  <span className={style.metaLabel}>Type:</span>
                                                                  <span className={style.metaValue}>{items.type}</span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowLOD}`}
                                                                >
                                                                  <span className={style.metaLabel}>LOD:</span>
                                                                  <span className={style.metaValue}>
                                                                    {items.difficulty}
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowPvalue}`}
                                                                >
                                                                  <span className={style.metaLabel}>P-value:</span>
                                                                  <span className={style.metaValue}>
                                                                    {items?.pvalue ?? '-'}
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  className={`${style.metaRow} ${style.QuasimetaRowTestAttempt}`}
                                                                >
                                                                  <span className={style.metaLabel}>
                                                                    Test Attempts:
                                                                  </span>
                                                                  <span className={style.metaValue}>
                                                                    {items?.test_attempts ?? '-'}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </>
                                                        ))
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              </Draggable>
                                            ))}
                                          {provided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>
                                    <footer
                                      className={`${style.sectionFooter} ${style.sectionFooter_new} ${isView ? style.isViewMainContainer : ''}`}
                                      style={{ marginTop: '16px' }}
                                    >
                                      {removeId.length > 0 && (
                                        <div className={`${style.footer_content} ${style.footer_content_new}`}>
                                          <div style={{ fontWeight: '500' }}>Selected Questions</div>
                                          <div>
                                            {removeId.length ?? 0}
                                            {/* {sectionItem?.sets
                                            .find((set) => set.id === selectedSetId)
                                            ?.questions?.reduce((count, q) => count + (q.questions?.length || 0), 0)} */}
                                            <b style={{ color: 'lightgray' }}>
                                              {' '}
                                              /{' '}
                                              {
                                                sectionItem?.sets.find((set) => set.id === selectedSetId)
                                                  ?.no_of_questions
                                              }
                                            </b>
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        className={`${style.footer_content_mid} ${style.footer_content_mid_new} ${style.footer_content_start} ${style.footer_content_start_new}`}
                                        style={{ marginLeft: '0px' }}
                                      >
                                        {/* {sectionItem.sets
                                          .find((set) => set.id === selectedSetId)
                                          ?.questions?.map((items, i) =>
                                            items?.questions?.map((question) => (
                                              <span key={i} className={`${style.closeIds} ${style.closeIds_new}`}>
                                                {question.question_id}{' '}
                                                {!isView && (
                                                <img
                                                  src={deleteId}
                                                  className={style.iconInfo}
                                                  style={{ marginLeft: '3px' }}
                                                  // onClick={(e) => removeQueIds(items)}
                                                  onClick={(e) => {
                                                    removeQueIds(e, items);
                                                  }}
                                                  alt="delete"
                                                />
                                              )}
                                              </span>
                                            ))
                                          )} */}

                                        {removeId.map((question) => (
                                          <span key={i} className={`${style.closeIds} ${style.closeIds_new}`}>
                                            {question}
                                          </span>
                                        ))}
                                      </div>

                                      <div
                                        className={`${style.footer_content_right} ${style.footer_content_right_new}`}
                                      >
                                        {!isView && (
                                          <>
                                            {(onAdd || (isEdit && testDetails?.delete_question)) && (
                                              <span
                                                className={style.footerDeleteLabel}
                                                onClick={() => DeleteIdFromList()}
                                              >
                                                Delete Selected
                                              </span>
                                            )}
                                            <div
                                              className={`${style.drop_score} ${style.drop_score_new} ${style.markingLogic}`}
                                              style={{ marginRight: '10px' }}
                                              onClick={() => OpenMarkingLogic()}
                                            >
                                              Set Marking Logic &nbsp;
                                              <svg
                                                width="26"
                                                style={{
                                                  rotate: markingLogicStatus ? '' : '180deg',
                                                }}
                                                height="24"
                                                viewBox="0 0 26 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clipPath="url(#clip0_1445_47115)">
                                                  <path
                                                    d="M5.01822 16.0469L11.7264 9.52687C12.5186 8.75687 13.815 8.75687 14.6072 9.52687L21.3154 16.0469"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_1445_47115">
                                                    <rect
                                                      x="0.820312"
                                                      width="24.6927"
                                                      height="24"
                                                      rx="12"
                                                      fill="white"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          </>
                                        )}
                                        <div
                                          className={style.logics_input}
                                          style={{
                                            display: markingLogicStatus ? 'block' : 'none',
                                          }}
                                        >
                                          <div className={style.new} onClick={() => AddNewScore()}>
                                            <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                stroke="#00ABFB"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M7.5 12H16.5"
                                                stroke="#00ABFB"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M12 16.5V7.5"
                                                stroke="#00ABFB"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                            &nbsp; New Scoring Logic
                                          </div>
                                          <div className={style.QuasiScoring}>
                                            {markingLogic?.map((items, i) => (
                                              <div key={i} className={style.QuasiInputs}>
                                                <input
                                                  type="radio"
                                                  key={items}
                                                  id={i}
                                                  name="logic"
                                                  onChange={() => SelectedMarkingLogic(items)}
                                                />
                                                <input
                                                  onKeyDown={(e) => {
                                                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onWheel={(e) => e.target.blur()}
                                                  autoComplete="off"
                                                  onChange={(e) => handleCorrectAnswerChange(e, i)}
                                                  type="number"
                                                  className={style.inputsNumber}
                                                  style={{
                                                    display: 'inline',
                                                    width: '30%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    marginTop: '3px',
                                                  }}
                                                  value={items?.unattempted_penalty}
                                                />
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </footer>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p>Please select a set</p>
                            )}
                          </div>
                        </div>
                        <div style={{ marginTop: '1rem' }} className={style.performBT}>
                          <button
                            className={` ${style.btOne} ${style.common}`}
                            onClick={() => dispatch(changeAdd_test_screen(0))}
                          >
                            Back
                          </button>
                          {!isView && (
                            <button
                              className={` ${style.btTwo} ${style.common}`}
                              onClick={() => {
                                updateSection();
                              }}
                            >
                              Save And Continue
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              ))}
          </DragDropContext>

          {modal ? (
            <BrowsingQuestion
              SetSelectIds={SetSelectIds}
              selectIds={selectIds}
              selectedIds={
                body.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId)
                  ?.questions
              }
              setModal={setModal}
              totalQuestion={
                body.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId)
                  ?.no_of_questions
              }
              AddToTestPaper={AddToTestPaper}
              testType={testType}
              sectionName={body.groups[groupsButton].sections[sectionButton].section_name}
              roundNo={
                body.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId)?.round_no
              }
              setName={
                body.groups[groupsButton].sections[sectionButton].sets.find((set) => set.id === selectedSetId)?.set_name
              }
            />
          ) : (
            ''
          )}
        </div>
      </div>
      <PreviewModal
        onEdit={handleEdit}
        questionAccess={questionAccess}
        selectedQuestion={selectedQuestion}
        isOpen={isPreviewopen}
        onClose={handleCloseModal}
        setIsDuplicateModalOpen={setIsModalOpen}
        setModalData={setModalData}
        modalData={modalData}
        setIsDuplicatePreview={setIsDuplicatePreview}
        iframeSrc="/question-content-url"
      />
      <QuestionListModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={onConfirmDuplicate}
        data={modalData} // Pass modalData to the modal
        isDuplicatePreview={isDuplicatePreview}
      />
      <LockModal
        modalData={modalModalData}
        forwardButton={() => navigate('/edit-question', { state: questionItem })}
        modalMedium={modalMedium}
        closeModalMedium={closeModalMedium}
      />
    </>
  );
};

QuasiSections.propTypes = {
  getData: PropTypes.func,
  isEdit: PropTypes.any,
  isView: PropTypes.any,
  onAdd: PropTypes.any,
};

export default QuasiSections;
